const DOMAIN_NAME = 'profileChangeRequests';

// Backend Menu.menuId for the admin "Change Requests" page
const CHANGE_REQUESTS_ROUTE_ID = 42;

const ROWS_PER_PAGE = 10;

const CHANGE_REQUEST_FORM_NAME = 'profileChangeRequest';

const STATUS = {
    pending: 'pending',
    approved: 'approved',
    rejected: 'rejected',
    partiallyApproved: 'partially approved',
    cancelled: 'cancelled'
};

const STATUS_FILTER_OPTIONS = [
    { value: null, label: 'All Status' },
    { value: STATUS.pending, label: 'Pending' },
    { value: STATUS.approved, label: 'Approved' },
    { value: STATUS.partiallyApproved, label: 'Partially Approved' },
    { value: STATUS.rejected, label: 'Rejected' },
    { value: STATUS.cancelled, label: 'Cancelled' }
];

export {
    DOMAIN_NAME,
    CHANGE_REQUESTS_ROUTE_ID,
    ROWS_PER_PAGE,
    CHANGE_REQUEST_FORM_NAME,
    STATUS,
    STATUS_FILTER_OPTIONS
};
